import { createSlice } from "@reduxjs/toolkit";

const initialState={
    keyboardStatus:false
}

const keyboardSlice=createSlice({
    name:"keyboard",
    initialState,
    reducers:{
        setKeyboardStatusRedux:(state,action)=>{
            state.keyboardStatus=action.payload
        }
        
    }
})

export const {setKeyboardStatusRedux}=keyboardSlice.actions;
export default keyboardSlice.reducer;